import AppPermissionsView from './AppPermissionsView'

export default function AppPermissionsContainer() {
    return <AppPermissionsView />
}
